module.exports = __webpack_public_path__ + "advantages_SP.jpg";